module.exports = __webpack_public_path__ + "img/menu_gante.d0a63265.svg";